export const TRANS = {
  author: { en: 'by', fi: 'kirjoittaja' },
  authors: { en: 'by', fi: 'kirjoittajat' },
};
